export var localBreadcrumbs = function localBreadcrumbs(strictLocalize) {
  return {
    HOME: strictLocalize({
      id: "zXMIoX",
      defaultMessage: [{
        "type": 0,
        "value": "Accueil"
      }]
    }),
    POPULAR_GUIDES: strictLocalize({
      id: "AuCq+K",
      defaultMessage: [{
        "type": 0,
        "value": "Guides populaires"
      }]
    }),
    SEARCH: strictLocalize({
      id: "heC0E1",
      defaultMessage: [{
        "type": 0,
        "value": "Rechercher"
      }]
    }),
    RETAILER_GUIDES: strictLocalize({
      id: "0uLEFs",
      defaultMessage: [{
        "type": 0,
        "value": "Guides des commerçants"
      }]
    }),
    BRAND_GUIDES: strictLocalize({
      id: "VAqQy9",
      defaultMessage: [{
        "type": 0,
        "value": "Guides des marques"
      }]
    })
  };
};